import useTranslator from "../../../../hooks/useTranslator";

const WELCOME_MEDIA_URL =
  "https://sdk.onfido.com/assets/icons/welcome-media.svg";

const VerificationStartScreen = ({ onStart }: { onStart: () => void }) => {
  const { _t } = useTranslator();
  return (
    <div className="kyc-verification-start">
      <div className="kyc-verification-start-media">
        <img
          src={WELCOME_MEDIA_URL}
          alt=""
          className="kyc-verification-start-media-img"
        />
      </div>

      <div className="kyc-verification-start-copy">
        <h3>{_t("Verify your identity", "onfido kyc")}</h3>
        <p>{_t("It should take a few minutes", "onfido kyc")}</p>
      </div>

      <div className="kyc-verification-start-actions">
        <button
          type="button"
          className="kyc-verification-start-button"
          onClick={onStart}
        >
          {_t("Start verification", "onfido kyc")}
        </button>
      </div>
    </div>
  );
};

export default VerificationStartScreen;
